import { render } from "./CoordenadoriaPerfilDeDados.vue?vue&type=template&id=22a91fe5&scoped=true&ts=true"
import script from "./CoordenadoriaPerfilDeDados.vue?vue&type=script&lang=ts"
export * from "./CoordenadoriaPerfilDeDados.vue?vue&type=script&lang=ts"

import "./CoordenadoriaPerfilDeDados.vue?vue&type=style&index=0&id=22a91fe5&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a91fe5"],['__file',"src/components/Coordenadoria/CoordenadoriaPerfilDeDados.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22a91fe5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22a91fe5', __exports__)) {
    api.reload('22a91fe5', __exports__)
  }
  
  module.hot.accept("./CoordenadoriaPerfilDeDados.vue?vue&type=template&id=22a91fe5&scoped=true&ts=true", () => {
    api.rerender('22a91fe5', render)
  })

}


export default __exports__